export default {
  init() {
    $('.header__main-menu .main-menu__sub-menu--1__item > a[data-image]').each(function() {
      if ($(this).find('.menu-item__media').length == 0) {
        $(this).append('<div class="menu-item__media"><img src="' + $(this).attr('data-image') + '"/></div>')
      }
    })
    $('.header__main-menu .main-menu__item--parent > a[data-title]').each(function() {
      if ($(this).next('.main-menu__sub-menu').find('.sub-menu-columns').find('.sub-menu-wrapper__cta').length == 0) {
        $(this).next('.main-menu__sub-menu').find('.sub-menu-columns').append('<div class="sub-menu-wrapper__cta"></div>')
      }
      $(this).next('.main-menu__sub-menu').find('.sub-menu-columns .sub-menu-wrapper__cta').append('<p class="sub-menu-wrapper__cta__title">' + $(this).attr('data-title') + '</p>')
    })
    $('.header__main-menu .main-menu__item--parent > a[data-button-url][data-button-label]').each(function() {
      if ($(this).next('.main-menu__sub-menu').find('.sub-menu-columns').find('.sub-menu-wrapper__cta').length == 0) {
        $(this).next('.main-menu__sub-menu').find('.sub-menu-columns').append('<div class="sub-menu-wrapper__cta"></div>')
      }
      $(this).next('.main-menu__sub-menu').find('.sub-menu-columns .sub-menu-wrapper__cta').append('<a target="' + $(this).attr('data-button-target') + '" href="' + $(this).attr('data-button-url') + '" class="sub-menu-wrapper__cta__link btn-icon bg-black">' + $(this).attr('data-button-label') + '</a>')
    })

    var cta = $('.header .secondary-menu .secondary-menu__item[class*=secondary-menu__item--btn]:not([class*=secondary-menu__item--btn-icon-only]):not([class*=secondary-menu__item--desktop-only]) a')
    if (cta.length) {
      $('.header').find('.header__ctas').append(cta.clone())
    }

    $('.header__mobile-menu .main-menu__item.main-menu__item--parent').each(function() {
      var parent_item = $(this);
      var link = $(this).find('> a')
      var back_label = 'Retour';
      if ($('html').attr('lang') == 'en-CA') {
        back_label = 'Back';
      }
      var back_button = $('<button class="back-button"><i class="icon-left"></i>' + back_label + '</button>')
      back_button.click(function() {
        parent_item.removeClass('--opened')
      })
      parent_item.find('> ul').prepend(back_button)

      link.click(function() {
        parent_item.addClass('--opened')
        return false;
      })
    })

    $('.header__mobile-menu .secondary-mobile__item--parent').each(function() {
      $(this).Drawer({
        toggle: '.secondary-mobile__link',
        content: '.secondary-mobile__sub-menu--1'
      })
      var link = $(this).find('.drawer__toggle:not([href="#"])[href]').clone()
      $(this).find('.drawer__toggle:not([href="#"])[href]').attr('href', '');
      link.html('<i class="icon-right-2"></i>')
      link.removeClass('secondary-mobile__link').addClass('secondary-mobile__mobile-link')
      $(this).prepend(link)
    })

    $('.header__burger-wrapper').before($('.quick-links__item.--wpml a').clone());



    // Top bar
    $(window).on('load orientationchange resize scroll message_dismissed', topBarHeight)
    topBarHeight()

    function topBarHeight() {
      let $topBar = $('.featured-message--style-top-bar'),
      $menuBar = $('.header__main'),
      topBarHeight = 0,
      menuBarHeight = 0,
      headerHeight = 0
      if ($topBar.length && $topBar.is(':visible')) {
        topBarHeight = $topBar.outerHeight(false)
      }
      if ($menuBar.length && $menuBar.is(':visible')) {
        menuBarHeight = $menuBar.outerHeight(false)
      }
      headerHeight = menuBarHeight
      if (topBarHeight && !$('body').hasClass('header--scroll-down') && !$('body').hasClass('--menu-open')) {
        headerHeight += topBarHeight
      }
      $('.app').css({
        '--top-bar-height': topBarHeight + 'px',
        '--menu-height': menuBarHeight + 'px',
        '--header-height': headerHeight + 'px',
      })
      $('.app').addClass('--ready')
    }

    // Lang switcher
    $('.header .--wpml > a').text(get_l10n().LANG_SWITCH)
  }
}
